__turbopack_context__.v({
  "button": "_18KYtW_button",
  "icon": "_18KYtW_icon",
  "noWrap": "_18KYtW_noWrap",
  "text": "_18KYtW_text",
});
